<template>
  <div>
    <el-dialog
      title="按购买记录打标"
      :visible.sync="showDialog"
      width="70%"
      :close-on-click-modal="true"
      :close-on-press-escape="true"
      :before-close="cancelAction"
    >
      <el-main>
        <el-form
ref="form"
:inline="true"
:model="form"
label-width="100px"
>
          <el-form-item label="下单时间">
            <el-date-picker
              v-model="dateRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              @change="changeDate"
            />
          </el-form-item>
          <el-form-item label="商品">
            <el-input
v-model="input"
placeholder="请选择商品"
:disabled="true"
>
              <template slot="append">
                <el-button @click="goodsVisible = true">
选择商品
</el-button>
              </template>
            </el-input>
          </el-form-item>
          <el-button
type="primary"
@click="handleFetch"
>
匹配查询
</el-button>
        </el-form>
        <el-row>
          <el-col :span="20">
            <div class="labels">
              <div
v-for="(item, index) in list"
:key="index"
class="label-lists"
>
                <div class="label-title">
                  {{ item.title }}
                </div>
                <SpLabelList
                  :label-list="item.children"
                  :tags-id="item.id"
                  :selection-babel="true"
                  :readonly="readonly"
                />
              </div>
            </div>
            <el-button
v-if="!readonly"
type="text"
@click="editLabelVisible = true"
>
              新建标签组
            </el-button>
          </el-col>
          <el-col :span="4">
            <div class="p10">
              <div class="fs16">
匹配客户数
</div>
              <div class="fs32">
{{ total_count }}
</div>
            </div>
          </el-col>
        </el-row>
      </el-main>
      <el-footer>
        <el-button @click="cancelAction">
取消
</el-button>
        <el-button
type="primary"
:disabled="total_count === 0"
@click="handleConfirm"
>
          确定
        </el-button>
      </el-footer>
    </el-dialog>
    <!-- 选择商品 -->
    <GoodsSelect
      :goods-visible="goodsVisible"
      :select-data="selectGoodsData"
      :title="goodsTitle"
      @closeGoodsDialog="closeGoodsDialog"
      @chooseGoods="chooseGoods"
    />

    <!-- 编辑组件 -->
    <SpEditLabel
v-model="editLabelVisible"
@submitLabel="submitLabel"
/>
  </div>
</template>

<script>
import moment from 'moment'
import GoodsSelect from '@/components/goodsSelect'

export default {
  name: 'Mark',
  components: {
    GoodsSelect
  },
  props: {
    markVisible: {
      type: Boolean,
      default: false
    },
    markData: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      input: '',
      form: { item_bn: '' },
      dateRange: ['', ''],
      goodsVisible: false,
      selectGoodsData: [],
      goodsTitle: '选择商品',
      total_count: 0,
      readonly: false,
      list: [],
      editLabelVisible: false
    }
  },
  computed: {
    showDialog () {
      return this.markVisible
    }
  },
  watch: {
    showDialog (newVal, oldVal) {
      console.log(newVal)
      if (newVal) {
        if (this.markData[1]) {
          this.form = this.markData[1]
        } else {
          this.form = { item_bn: '' }
          this.input = '请选择商品'
          this.selectGoodsData = []
          this.total_count = 0
          this.init()
        }
      } else {
        this.form = { item_bn: '' }
        this.input = '请选择商品'
        this.selectGoodsData = []
        this.total_count = 0
        this.init()
      }
    }
  },
  created () {
    this.init()
  },
  methods: {
    // 关闭模态框
    cancelAction () {
      this.$emit('markVisibleChange', [false])
    },
    handleConfirm () {
      let params = this.form
      if (this.dateRange[0] && this.dateRange[1]) {
        params.pay_start_time = moment(this.dateRange[0]).format('YYYY-MM-DD HH:mm:ss')
        params.pay_end_time = moment(this.dateRange[1]).format('YYYY-MM-DD HH:mm:ss')
      }
      let selectBabelList = []
      this.list.forEach((v) => {
        v.children &&
          v.children.forEach((item) => {
            if (item.selected) {
              selectBabelList.push(item)
            }
          })
      })
      let tags_id = []

      selectBabelList.forEach((v) => {
        tags_id.push(v.id)
      })
      params.tags_id = tags_id
      this.$emit('markVisibleChange', [false, params])
    },
    selectImageData (selectdata) {
      this.imageUrl = selectdata
    },
    // 变更日期
    changeDate (e) {
      if (e) {
        this.form.pay_start_time = e[0]
        this.form.pay_end_time = e[1]

        this.dateRange = e
      } else {
        this.form.pay_start_time = ''
        this.form.pay_end_time = ''
        this.dateRange = ['', '']
      }
    },
    closeGoodsDialog () {
      this.goodsVisible = false
    },
    chooseGoods (selectdata, ids) {
      this.selectGoodsData = selectdata
      this.input = `已选择 ${this.selectGoodsData.length} 件商品`
      this.form.item_bn = this.selectGoodsData
        .map((v) => {
          return v.item_bn
        })
        .toString()
      this.goodsVisible = false
    },
    async handleFetch () {
      // console.log(this.form)
      // if (!this.form.item_bn) {
      //   return this.$message.error('请选择商品')
      // }
      const params = this.form
      const data = await this.$api.customer.matched_customers(params)
      if (data) {
        this.total_count = data.total_count
      }
    },
    async init () {
      const data = await this.$api.customer.getTagsList({
        page: 1,
        page_size: 999999
      })
      if (data) {
        // 可选标签的数据回显
        if (this.showSelectedTags && this.tagsList && this.tagsList.length > 0) {
          data.list.forEach((v) => {
            v.children &&
              v.children.forEach((vv) => {
                if (this.tagsList.findIndex((item) => item.id === vv.id) !== -1) {
                  vv.selected = true
                }
              })
          })
        }
        this.list = data.list
      }
    },
    submitLabel () {
      this.init()
      this.editLabelVisible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.ml10 {
  margin-left: 10px;
}
.p10 {
  padding: 10px;
}
.fs16 {
  font-size: 16px;
}
.fs32 {
  font-size: 32px;
}
.labels {
  max-height: 400px;
  overflow: auto;
}
.label-lists {
  margin-bottom: 12px;
  .label-title {
    margin-bottom: 6px;
    line-height: 22px !important;
  }
}
</style>
